

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Badge, Table, Spinner, Container, Button, Alert, Modal } from 'react-bootstrap';
// import config from '../../Common/Configurations/APIConfig';
// import { useNavigate } from 'react-router-dom';

// function CustomerAppointments() {
//     const [appointments, setAppointments] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState('');
//     const [showCancelModal, setShowCancelModal] = useState(false);
//     const [selectedAppointment, setSelectedAppointment] = useState(null);
//     const navigate = useNavigate();

//     // Get logged in user info
//     const userId = localStorage.getItem('userId');
//     const userEmail = localStorage.getItem('userEmail');
//     const userName = localStorage.getItem('userName') || 'Customer';

//     useEffect(() => {
//         if (!userId) {
//             setError('Please login to view your appointments');
//             setLoading(false);
//             return;
//         }
//         fetchCustomerAppointments();
//     }, [userId]);

//     const fetchCustomerAppointments = async () => {
//         try {
//             setLoading(true);
//             setError('');
            
//             // Use the user ID endpoint
//             const res = await axios.get(`${config.APIACTIVEURL}${config.GETAPPOINTMENTSBYUSERID}/${userId}`);
            
//             if (Array.isArray(res.data)) {
//                 setAppointments(res.data);
//             } else if (res.data?.data && Array.isArray(res.data.data)) {
//                 setAppointments(res.data.data);
//             } else {
//                 setAppointments([]);
//             }
//         } catch (err) {
//             console.error("Fetch Customer Appointments Error", err);
//             if (err.response?.status === 404) {
//                 setError('No appointments found for your account');
//             } else {
//                 setError('Failed to load your appointments. Please try again later.');
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     const getStatusColor = (status) => {
//         const s = status?.toLowerCase();
//         if (s === 'pending' || s === 'scheduled') return 'warning';
//         if (s === 'confirmed' || s === 'accepted') return 'info';
//         if (s === 'completed' || s === 'served') return 'success';
//         if (s === 'cancelled' || s === 'rejected') return 'danger';
//         if (s === 'noshow') return 'secondary';
//         return 'primary';
//     };

//     // --- INPUT = OUTPUT TIMING FIX ---
//     const formatDateTime = (dateString) => {
//         if (!dateString) return 'N/A';
        
//         // Logic: Remove 'Z' if present and take only the literal time portion.
//         // This stops the browser from adjusting the hours based on the user's location.
//         const cleanDate = dateString.replace('Z', '').split('.')[0];
//         const d = new Date(cleanDate);

//         return d.toLocaleDateString('en-GB', {
//             day: 'numeric',
//             month: 'short',
//             year: 'numeric'
//         }) + ' ' + d.toLocaleTimeString([], { 
//             hour: '2-digit', 
//             minute: '2-digit' 
//         });
//     };

//     // --- INPUT = OUTPUT TIMING FIX ---
//     const formatTime = (dateString) => {
//         if (!dateString) return 'N/A';
        
//         // Remove UTC 'Z' marker to treat the time as "Wall Clock Time"
//         const cleanDate = dateString.replace('Z', '').split('.')[0];
//         const d = new Date(cleanDate);

//         return d.toLocaleTimeString('en-US', {
//             hour: '2-digit',
//             minute: '2-digit',
//             hour12: true
//         });
//     };

//     const handleCancelClick = (appointment) => {
//         setSelectedAppointment(appointment);
//         setShowCancelModal(true);
//     };

//     if (!userId) {
//         return (
//             <Container className="mt-5 pt-5">
//                 <div className="text-center py-5">
//                     <Alert variant="warning" className="mx-auto" style={{ maxWidth: '500px' }}>
//                         <h4 className="alert-heading">Login Required</h4>
//                         <p>Please login to view your appointments.</p>
//                         <Button variant="primary" onClick={() => navigate('/')}>
//                             Go to Login
//                         </Button>
//                     </Alert>
//                 </div>
//             </Container>
//         );
//     }

//     if (loading) {
//         return (
//             <div className="text-center" style={{ marginTop: '200px' }}>
//                 <Spinner animation="border" variant="primary" />
//                 <p className="mt-2 fw-bold text-primary">Loading your appointments...</p>
//             </div>
//         );
//     }

//     return (
//         <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', width: '100%' }}>
//             <Container fluid className="px-4" style={{ marginTop: '120px', paddingBottom: '50px' }}>
//                 <div className="bg-white shadow-sm rounded-4 p-4 border-0">
//                     {/* Header */}
//                     <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
//                         <div>
//                             <h2 className="fw-bold mb-1 text-dark">My Appointments</h2>
//                             <p className="text-muted mb-0">
//                                 Welcome back, <span className="fw-bold text-primary">{userName}</span>
//                             </p>
//                         </div>
//                         <div className="d-flex gap-2">
//                             <Badge bg="primary" className="rounded-pill px-3 py-2 fs-6">
//                                 {appointments.length} Appointment{appointments.length !== 1 ? 's' : ''}
//                             </Badge>
//                         </div>
//                     </div>

//                     <div className="table-responsive">
//                         <table className="table table-hover align-middle mb-0">
//                             <thead className="table-light">
//                                 <tr className="small text-uppercase text-muted">
//                                     <th className="ps-3 py-3">Appointment </th>
//                                     <th>Salon & Service</th>
//                                     <th>Staff</th>
//                                     <th>Date & Time</th>
//                                     <th>Status</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {appointments.map((appointment) => (
//                                     <tr key={appointment.appointmentId}>
//                                         <td className="ps-3 py-3">
//                                             <div className="fw-bold text-primary">
//                                                 {appointment.appointmentNo}
//                                             </div>
//                                         </td>
//                                         <td>
//                                             <div>
//                                                 <div className="fw-bold text-dark">
//                                                     {appointment.salon?.name || "Salon"}
//                                                 </div>
//                                                 <div className="small text-muted">
//                                                     {appointment.serviceType?.name || "Service"}
//                                                 </div>
//                                             </div>
//                                         </td>
//                                         <td>
//                                             <div className="fw-bold">
//                                                 {appointment.staff?.name || "Any Available"}
//                                             </div>
//                                         </td>
//                                         <td>
//                                             <div className="fw-bold">
//                                                 {formatDateTime(appointment.startTime)}
//                                             </div>
//                                             <div className="small text-muted">
//                                                 {formatTime(appointment.startTime)} - {formatTime(appointment.endTime)}
//                                             </div>
//                                         </td>
//                                         <td>
//                                             <Badge 
//                                                 bg={getStatusColor(appointment.status)} 
//                                                 className="rounded-pill px-3 py-2"
//                                             >
//                                                 {appointment.status}
//                                             </Badge>
//                                         </td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//             </Container>
//         </div>
//     );
// }

// export default CustomerAppointments;

//web view 


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Badge, Table, Spinner, Container, Button, Alert, Modal } from 'react-bootstrap';
import config from '../../Common/Configurations/APIConfig';
import { useNavigate } from 'react-router-dom';

function CustomerAppointments() {
    const [appointments, setAppointments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [selectedAppointment, setSelectedAppointment] = useState(null);
    const navigate = useNavigate();

    const userId = localStorage.getItem('userId');
    const userName = localStorage.getItem('userName') || 'Customer';

    useEffect(() => {
        if (!userId) { setError('Please login to view your appointments'); setLoading(false); return; }
        fetchCustomerAppointments();
    }, [userId]);

    const fetchCustomerAppointments = async () => {
        try {
            setLoading(true);
            setError('');
            const res = await axios.get(`${config.APIACTIVEURL}${config.GETAPPOINTMENTSBYUSERID}/${userId}`);
            if (Array.isArray(res.data)) {
                setAppointments(res.data);
            } else if (res.data?.data && Array.isArray(res.data.data)) {
                setAppointments(res.data.data);
            } else { setAppointments([]); }
        } catch (err) {
            console.error("Fetch Customer Appointments Error", err);
            setError('Failed to load your appointments.');
        } finally { setLoading(false); }
    };

    const getStatusColor = (status) => {
        const s = status?.toLowerCase();
        if (s === 'pending' || s === 'scheduled') return 'warning';
        if (s === 'confirmed' || s === 'accepted') return 'info';
        if (s === 'completed' || s === 'served') return 'success';
        if (s === 'cancelled' || s === 'rejected') return 'danger';
        return 'primary';
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return 'N/A';
        const cleanDate = dateString.replace('Z', '').split('.')[0];
        const d = new Date(cleanDate);
        return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) + ' ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    const formatTime = (dateString) => {
        if (!dateString) return 'N/A';
        const cleanDate = dateString.replace('Z', '').split('.')[0];
        const d = new Date(cleanDate);
        return d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
    };

    if (loading) return <div className="text-center" style={{ marginTop: '200px' }}><Spinner animation="border" variant="primary" /></div>;

    return (
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', width: '100%' }}>
            <Container fluid className="px-2 px-md-4" style={{ marginTop: '100px', paddingBottom: '50px' }}>
                <div className="bg-white shadow-sm rounded-4 p-3 p-md-4 border-0">
                    {/* Header */}
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
                        <div>
                            <h2 className="fw-bold mb-1 text-dark">My Appointments</h2>
                            <p className="text-muted mb-0">Welcome back, <span className="fw-bold text-primary">{userName}</span></p>
                        </div>
                        <Badge bg="primary" className="rounded-pill px-3 py-2 fs-6 align-self-start">{appointments.length} Appointment(s)</Badge>
                    </div>

                    {/* Desktop Table */}
                    <div className="table-responsive d-none d-md-block">
                        <table className="table table-hover align-middle mb-0">
                            <thead className="table-light">
                                <tr className="small text-uppercase text-muted">
                                    <th className="ps-3 py-3">No</th>
                                    <th>Salon & Service</th>
                                    <th>Staff</th>
                                    <th>Date & Time</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {appointments.map((appointment) => (
                                    <tr key={appointment.appointmentId}>
                                        <td className="ps-3 py-3 fw-bold text-primary">{appointment.appointmentNo}</td>
                                        <td>
                                            <div className="fw-bold text-dark">{appointment.salon?.name || "Salon"}</div>
                                            <div className="small text-muted">{appointment.serviceType?.name || "Service"}</div>
                                        </td>
                                        <td><div className="fw-bold">{appointment.staff?.name || "Any Available"}</div></td>
                                        <td>
                                            <div className="fw-bold">{formatDateTime(appointment.startTime)}</div>
                                            <div className="small text-muted">{formatTime(appointment.startTime)} - {formatTime(appointment.endTime)}</div>
                                        </td>
                                        <td><Badge bg={getStatusColor(appointment.status)} className="rounded-pill px-3 py-2">{appointment.status}</Badge></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Mobile Cards */}
                    <div className="d-md-none">
                        {appointments.map((appointment) => (
                            <div key={appointment.appointmentId} className="border rounded-3 p-3 mb-3 shadow-sm">
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                    <span className="fw-bold text-primary">#{appointment.appointmentNo}</span>
                                    <Badge bg={getStatusColor(appointment.status)} className="rounded-pill">{appointment.status}</Badge>
                                </div>
                                <h6 className="fw-bold mb-1">{appointment.salon?.name}</h6>
                                <div className="text-muted small mb-2">{appointment.serviceType?.name}</div>
                                <div className="mb-2">
                                    <i className="ri-calendar-line me-1"></i> {formatDateTime(appointment.startTime)}
                                </div>
                                <div className="d-flex justify-content-between border-top pt-2">
                                    <small className="text-muted">Staff: {appointment.staff?.name || "Any"}</small>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default CustomerAppointments;